import ChipListSkeleton from './ChipListSkeleton'
export default ChipListSkeleton
